var map = {
	"./appAsset-brand--axteroid-icon-test.svg": "./src/assets/appAsset-brand--axteroid-icon-test.svg",
	"./appAsset-brand--axteroid-icon.svg": "./src/assets/appAsset-brand--axteroid-icon.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets sync recursive ^\\.\\/appAsset\\-brand\\-\\-axteroid\\-icon.*\\.svg$";